import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.MENU.TEXT'
       // isTitle: true
    },
    {
        id: 2,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'home',
        link: '/dashboard',
    },
    {
        id: 3,
        label: 'Sales Invoice',
        icon: 'users',
        subItems: [
            {
                id: 4,
                label: 'Create',
                link: '/salesinvoice/create',
                parentId: 3
            },
            {
                id: 5,
                label: 'Details',
                link: '/salesinvoice/details',
                parentId: 3
            },
            {
                id: 6,
                label: 'List',
                link: '/salesinvoice/list',
                parentId: 3
            }
          
        ]
    },
    {
        id: 7,
        label: 'Product',
        icon: 'briefcase',
        subItems: [
            {
                id: 8,
                label: 'Create',
                link: '/Product/create',
                parentId: 7
            },
            {
                id: 9,
                label: 'Details',
                link: '/Product/details',
                parentId: 7
            },
            {
                id: 10,
                label: 'List',
                link: '/inventory/ProductList',
                parentId: 7
            }
          
        ]
    },
    {
        id: 11,
        label: 'Product Group',
        icon: 'gift',
        subItems: [
            {
                id: 12,
                label: 'Create',
                link: '/Branch/create',
                parentId: 11
            },
            {
                id: 13,
                label: 'Details',
                link: '/Branch/details',
                parentId: 11
            },
            {
                id: 14,
                label: 'List',
                link: '/inventory',
                parentId: 11
            }
          
        ]
    },
    {
        id: 15,
        label: 'Agent',
        icon: 'box',
        subItems: [
            {
                id: 16,
                label: 'Create',
                link: '/salesinvoice/create',
                parentId: 15
            },
            {
                id: 17,
                label: 'Details',
                link: '/salesinvoice/details',
                parentId: 15
            },
            {
                id: 18,
                label: 'List',
                link: '/salesinvoice/list',
                parentId: 15
            }
          
        ]
    }
   
];

